import { Component, computed, inject, input } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';

import {
  IonToggle,
  IonSelect,
  IonSelectOption,
} from '@ionic/angular/standalone';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { PwaService } from 'src/app/services/pwa.service';
import { UserService } from 'src/app/services/user.service';

export interface SettingsSelectOption {
  value: string;
  labelKey: string;
  selectedLabelKey?: string;
}

@Component({
  standalone: true,
  selector: 'app-settings-control',
  imports: [
    IonToggle,
    IonSelect,
    IonSelectOption,
    TranslateModule,
    ReactiveFormsModule,
  ],
  templateUrl: './settings-control.component.html',
  styleUrl: './settings-control.component.scss',
})
export class SettingsControlComponent {
  readonly type = input.required<string>();
  readonly control = input.required<FormControl>();
  readonly options = input<SettingsSelectOption[] | undefined>();
  readonly titleInput = input<string | undefined>();
  readonly descriptionInput = input<string | undefined>();

  private readonly translate = inject(TranslateService);
  private readonly user = inject(UserService).user;

  private readonly pwaService = inject(PwaService);

  readonly isDesktop = this.pwaService.desktop;

  selectedText() {
    const val = this.control().value;
    const opts = this.options();
    if (!opts || val === undefined) return undefined;
    const selected = opts.find((o) => o.value === val);
    return selected?.selectedLabelKey
      ? this.translate.instant(selected.selectedLabelKey)
      : undefined;
  }

  readonly interfaceOptions = computed(() => {
    if (this.isDesktop()) return {};

    return {
      header: this.title(),
      cssClass: 'custom-actionsheet',
      buttons: [
        {
          text: this.translate.instant('settings.cancel'),
          cssClass: 'cancelBtn',
          role: 'cancel',
        },
      ],
    };
  });

  readonly title = computed(() => {
    if (this.titleInput() !== undefined) return this.titleInput();
    return this.translate.instant(`settings.control.${this.type()}.title`);
  });

  readonly description = computed(() => {
    if (this.descriptionInput() !== undefined) return this.descriptionInput();
    return this.translate.instant(`settings.control.${this.type()}.desc`);
  });
}
